import qs from 'query-string'
import { SetStateAction, Dispatch, memo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Annotations } from '@pdftron/webviewer'
import PDFViewer, {
    PDFViewModels,
} from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/PreviewPanel/PreviewItem/PDFViewer'
import {
    THREE_D_VIEWER_QUERY_PARAM,
    VIEWER_QUERY_PARAM,
} from '@Admin/AdminQuotingPage/constants'

const ANNOTATE_MODE = 'annotate'
const VIEW_MODE = 'view'

const MemoizedPDFViewer = memo(PDFViewer, (prevProps, nextProps) => {
    if (
        prevProps.attachmentId !== nextProps.attachmentId ||
        prevProps.fileName !== nextProps.fileName ||
        prevProps.mode !== nextProps.mode ||
        prevProps.pdfName !== nextProps.pdfName ||
        prevProps.pdfUrl !== nextProps.pdfUrl ||
        prevProps.qmrAttachmentAnnotationsUrl !==
            nextProps.qmrAttachmentAnnotationsUrl
    ) {
        return false
    }

    return true
})

export type ViewerModeType = typeof ANNOTATE_MODE | typeof VIEW_MODE

interface ImDfmPdfViewerPropsType {
    attachmentId: string
    fileName: string
    isLocatedInModal?: boolean
    pdfName: string
    pdfUrl: string
    qmrAttachmentAnnotationsUrl?: string
    setCurrentPdfData: (arg: string) => void
    setUnsavedAnno: Dispatch<SetStateAction<Annotations.Annotation[]>>
    unsavedAnno: Annotations.Annotation[]
    viewerMode?: ViewerModeType | null
}

const ImDfmPdfViewer = (props: ImDfmPdfViewerPropsType) => {
    const {
        attachmentId,
        fileName,
        isLocatedInModal,
        viewerMode = VIEW_MODE,
        pdfUrl,
        qmrAttachmentAnnotationsUrl,
        setCurrentPdfData,
        setUnsavedAnno,
        unsavedAnno,
    } = props

    const navigate = useNavigate()
    const { search } = useLocation()

    const onClickBackTo3d = () => {
        const currentQueryParams = qs.parse(search)

        const newQueryParams = {
            ...currentQueryParams,
        }

        newQueryParams[VIEWER_QUERY_PARAM] = THREE_D_VIEWER_QUERY_PARAM

        navigate(
            {
                search: qs.stringify(newQueryParams),
            },
            { replace: true },
        )
    }

    let mode = PDFViewModels.IM_DFM_3D_VIZ_VIEWER
    const onBackButtonClick = onClickBackTo3d

    if (viewerMode === ANNOTATE_MODE) {
        if (isLocatedInModal) {
            mode = PDFViewModels.IM_DFM_BUILDER_ANNOTATE
        } else {
            // Contains the Back to 3D model button
            mode = PDFViewModels.IM_DFM_ADMIN_ANNOTATE
        }
    }

    return (
        <MemoizedPDFViewer
            attachmentId={attachmentId}
            backTo3dModelButtonOnClick={onBackButtonClick}
            fileName={fileName}
            mode={mode}
            pdfName={fileName}
            pdfUrl={pdfUrl}
            qmrAttachmentAnnotationsUrl={qmrAttachmentAnnotationsUrl}
            setCurrentPdfData={setCurrentPdfData}
            setUnsavedAnno={setUnsavedAnno}
            unsavedAnno={unsavedAnno}
        />
    )
}

export default ImDfmPdfViewer
